import { PayInvoicePageContext } from "@auer-steel/Pages/PayInvoicePage";
import { AuerState } from "@auer-steel/Store/AuerState";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import updateBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/UpdateBillTo";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddressInfoDisplay from "@insite/content-library/Components/AddressInfoDisplay";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: AuerState) => ({
    invoicePaymentCollection: state.payInvoice.invoicePaymentCollection,
    billTo: state.payInvoice.invoicePaymentCollection.billingAddress,
    countries: getCurrentCountries(state),
    billToAddressFields: getAddressFieldsDataView(state).value?.billToAddressFields,
});

const mapDispatchToProps = {
    updateBillTo,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CurrentBillingAddressStyles {
    gridContainer?: GridContainerProps;
    headingGridItem?: GridItemProps;
    headingText?: TypographyProps;
    editLinkGridItem?: GridItemProps;
    addressInfoDisplayGridItem?: GridItemProps;
}

export const currentBillingAddressStyles: CurrentBillingAddressStyles = {
    gridContainer: { gap: 5 },
    headingGridItem: { width: 10 },
    headingText: { variant: "h5" },
    editLinkGridItem: { width: 2 },
    addressInfoDisplayGridItem: { width: 12 },
};

const styles = currentBillingAddressStyles;

const BillingAddress: React.FunctionComponent<Props> = (props: Props) => {
    if (props.invoicePaymentCollection.invoicePayments.length < 1) {
        return null;
    }
    const { billTo } = props;

    if (!billTo) {
        return null;
    }

    return (
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.headingGridItem}>
                <Typography {...styles.headingText}>{translate("Billing Information")}</Typography>
            </GridItem>
            <GridItem {...styles.addressInfoDisplayGridItem}>
                <AddressInfoDisplay
                    firstName={billTo.firstName}
                    lastName={billTo.lastName}
                    companyName={billTo.companyName}
                    attention={billTo.attention}
                    address1={billTo.address1}
                    address2={billTo.address2}
                    address3={billTo.address3}
                    address4={billTo.address4}
                    city={billTo.city}
                    state={billTo.state ? billTo.state.abbreviation : undefined}
                    postalCode={billTo.postalCode}
                    country={billTo.country ? billTo.country.abbreviation : undefined}
                    phone={billTo.phone}
                    fax={billTo.fax}
                    email={billTo.email}
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(BillingAddress),
    definition: {
        group: "Pay Invoice" as any,
        allowedContexts: [PayInvoicePageContext],
    },
};

export default widgetModule;
